function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7866 0H4.57702C3.41332 0.00167239 2.29764 0.464048 1.47399 1.286C0.650332 2.10795 0.185741 3.22258 0.181824 4.38611V25.6012C0.182383 26.7669 0.645493 27.8848 1.46951 28.7095C2.29353 29.5342 3.41113 29.9983 4.57702 30H13.4246V19.3925H9.90801V14.1236H13.4246V10.5461C13.4257 9.14799 13.9817 7.80741 14.9705 6.81876C15.9593 5.83011 17.3 5.2742 18.6984 5.27307H24.0294V10.5461H18.6984V14.1236H24.0294L23.1508 19.3967H18.7048V30H25.793C26.9579 29.9972 28.0742 29.5325 28.897 28.7079C29.7198 27.8832 30.1818 26.766 30.1818 25.6012V4.38611C30.1785 3.22241 29.714 2.10746 28.8903 1.28538C28.0665 0.463312 26.9505 0.00111518 25.7866 0Z",
  fill: "#BDBDBD"
});

function SvgIcFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.d0ffc161.svg";
export { ForwardRef as ReactComponent };